import { graphql } from "relay-runtime"

export const deSavePreventionProgramEngagementsMutation = graphql`
  mutation deSavePreventionProgramEngagementsMutation(
    $input: De_savePreventionProgramEngagementsInput!
    $addConnections: [ID!]!
  ) {
    savePreventionProgramEngagements: de_savePreventionProgramEngagements(input: $input) {
      patientPreventionProgramOutput @appendNode(connections: $addConnections, edgeTypeName: "PreventionProgramsEdge") {
        ...PatientPreventionProgramOutputFragment
      }
      errors {
        ... on Error {
          message
        }
      }
    }
  }
`
